import Hero from "./components/Hero";
import CategoryNav from "./components/CategoryNav";
import FeaturedVideos from "./components/FeaturedVideos";
import TrendingList from "./components/TrendingList";
import LatestUpdates from "./components/LatestUpdates";
import HomeFAQ from "./components/HomeFAQ";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <article>
          <Hero />
          <CategoryNav />
          <FeaturedVideos />
          <TrendingList />
          <LatestUpdates />
          <HomeFAQ />
        </article>
      </main>

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-900 text-center" aria-label="行动号召">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            随时随地，畅享视听盛宴
          </h2>
          <p className="text-sm md:text-base text-background-300 mb-8">
            聚合香蕉视频、红桃视频、91视频、蜜桃视频等热门平台，高清免费在线观看，不缓冲流畅播放
          </p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <a
              href="/category/dianying"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-medium bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-line"></i>
              开始观看
            </a>
            <a
              href="/about"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-medium border border-background-400 text-background-200 hover:bg-background-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解99视频
            </a>
          </div>
        </div>
      </section>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "99视频 - 香蕉视频与红桃视频在线观看 | 91视频蜜桃视频免费高清全集",
          description: "99视频聚合香蕉视频、红桃视频、91视频、蜜桃视频等热门视频平台，提供高清免费在线观看，不缓冲流畅播放，最新电影电视剧全集一站式收录。",
          url: "https://99video.com/",
          isPartOf: {
            "@type": "WebSite",
            name: "99视频",
            url: "https://99video.com",
          },
        })}
      </script>
    </>
  );
}